import React, { useState } from "react";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components (Custom Components ของโปรเจกต์คุณ)
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";

// Styles ที่ใช้ประจำในโปรเจกต์
const styles = {
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1,
    },
};
const useStyles = makeStyles(styles);

const MyCustomForm = (props) => {
    const classes = useStyles();
    const history = useHistory();

    // 1. State สำหรับเก็บข้อมูลฟอร์ม
    const [formData, setFormData] = useState({
        code: "",
        fullName: "",
        categoryKey: "",
        description: ""
    });

    const [isSaving, setIsSaving] = useState(false); // ไว้สำหรับ disable ปุ่มตอนกดเซฟ

    // ตัวอย่างข้อมูลสำหรับ Dropdown (TSSelect2)
    const categoryOptions = [
        { value: 1, label: "หมวดหมู่ A" },
        { value: 2, label: "หมวดหมู่ B" },
    ];

    // 2. Handlers สำหรับจัดการข้อมูลเมื่อมีการพิมพ์หรือเลือก
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSelectChange = (name, selectedOption) => {
        setFormData({ ...formData, [name]: selectedOption ? selectedOption.value : "" });
    };

    // 3. ฟังก์ชันบันทึกข้อมูล
    const handleSave = async () => {
        setIsSaving(true);
        try {
            console.log("ข้อมูลที่เตรียมส่งบันทึก:", formData);
            
            // ตัวอย่างการเรียก API
            // await axios.post('/api/v1/your-endpoint', formData);
            
            alert("บันทึกข้อมูลสำเร็จ!");
            // ถอยกลับไปหน้าก่อนหน้า หรือไปหน้า List
            // history.goBack(); 
        } catch (error) {
            console.error("Save Error:", error);
            alert("เกิดข้อผิดพลาดในการบันทึก");
        } finally {
            setIsSaving(false);
        }
    };

    // 4. ฟังก์ชันยกเลิก / ย้อนกลับ
    const handleCancel = () => {
        history.goBack(); // ย้อนกลับไปหน้าก่อนหน้า
    };

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        {/* --- ส่วนหัว Card --- */}
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>เพิ่ม/แก้ไข ข้อมูลพื้นฐาน</h4>
                        </CardHeader>
                        
                        {/* --- ส่วนเนื้อหา (ฟอร์ม) --- */}
                        <CardBody>
                            <Grid>
                                {/* แถวที่ 1 */}
                                <Col xs={12} sm={4} md={4}>
                                    <TSText
                                        icon="fas fa-barcode"
                                        name="code"
                                        label="รหัสข้อมูล"
                                        value={formData.code}
                                        onChange={handleInputChange}
                                        placeholder="กรอกรหัส..."
                                    />
                                </Col>
                                <Col xs={12} sm={8} md={8}>
                                    <TSText
                                        icon="far fa-user"
                                        name="fullName"
                                        label="ชื่อ-นามสกุล / ชื่อรายการ"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        placeholder="กรอกชื่อ..."
                                    />
                                </Col>

                                {/* แถวที่ 2 */}
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2
                                        isClearable={true}
                                        label="หมวดหมู่"
                                        options={categoryOptions}
                                        value={formData.categoryKey}
                                        onChange={(e) => handleSelectChange("categoryKey", e)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                    <TSText
                                        icon="fas fa-align-left"
                                        name="description"
                                        label="รายละเอียดเพิ่มเติม"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="ระบุรายละเอียด..."
                                    />
                                </Col>
                            </Grid>
                        </CardBody>

                        {/* --- ส่วนท้าย (ปุ่ม) --- */}
                        <CardFooter style={{ justifyContent: 'flex-end' }}>
                            <Button 
                                color="success" 
                                type="button" 
                                onClick={handleSave} 
                                disabled={isSaving}
                                style={{ marginRight: '10px' }}
                            >
                                <i className={isSaving ? "fas fa-spinner fa-spin" : "fas fa-save"} style={{ marginRight: '5px' }}></i> 
                                บันทึกข้อมูล
                            </Button>
                            
                            <Button 
                                color="transparent" 
                                type="button" 
                                onClick={handleCancel}
                                disabled={isSaving}
                            >
                                <i className="fas fa-times" style={{ marginRight: '5px' }}></i> 
                                ยกเลิก
                            </Button>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
};

export default MyCustomForm;